import React from 'react';
import PropTypes from 'prop-types';
import { FIELD_NAME_TO_LABEL_TABLE, displayValueForComponentName } from '../utilities/helpers';
import './ContractSummary.css';

function ContractSummary({ contract, contractSummaryClasses }) {
  const fieldNames = Object.keys(FIELD_NAME_TO_LABEL_TABLE);
  const summary = fieldNames.map((fieldName) => {
    const contractSummaryClass = contractSummaryClasses[fieldName];
    const displayValue = displayValueForComponentName(contractSummaryClass, contract[fieldName]);

    if (displayValue || displayValue === 0) {
      return (
        <div key={fieldName} className={`summary_item summary_${fieldName}`}>
          <span className="label">{FIELD_NAME_TO_LABEL_TABLE[fieldName]}:</span>{' '}
          <span className="field-value">{displayValue}</span>
        </div>
      );
    }
    return null;
  });

  return (
    <div className="contract-summary white-box item-box">
      <div className="inner">
        <h3>Contract Summary</h3>
        {summary}
      </div>
    </div>
  );
}
/* eslint-disable react/forbid-prop-types */
ContractSummary.propTypes = {
  contract: PropTypes.object.isRequired,
  contractSummaryClasses: PropTypes.object.isRequired,
  /* eslint-enable react/forbid-prop-types, react/require-default-props */
};

export default ContractSummary;



// WEBPACK FOOTER //
// ./src/components/ContractSummary.js